import React from 'react';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import { gql } from '@apollo/client';
import DatePicker from 'react-datepicker';
import { ReactComponent as PlusIcon } from '../../../assets/svg/plus-gray.svg';
import InputHeader from '../global/inputwithHeader';
import CustomDateInput from '../global/customDateInput';
import { ReactComponent as CriticalP } from '../../../assets/svg/critical_priority.svg';
import { ReactComponent as HighP } from '../../../assets/svg/high_priority.svg';
import { ReactComponent as LowP } from '../../../assets/svg/low_priority.svg';
import { ReactComponent as MediumP } from '../../../assets/svg/medium_priority.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/svg/notes-delete-icon.svg';
import _, { forEach } from 'lodash';
import { ReactComponent as Minus } from '../../../assets/svg/minus-circle.svg';

import { withRouter } from '../../../services/withRoute';

import Modal from '../../components/modals';
import Select from 'react-select';

import jwt_decode from 'jwt-decode';

import moment from 'moment';
import jwtDecode from 'jwt-decode';
const updateTask = gql`
	mutation UpdateTask($updateTaskId: ID!, $updateInput: updateTaskInput!) {
		updateTask(id: $updateTaskId, updateInput: $updateInput) {
			id
		}
	}
`;
class EditTask extends ProjectsGraphQlController {
	constructor(props) {
		super(props);
		this.state = {
			dueDate: this.props.modalData.dueDate,
			selecteddueDate: null,
			description: this.props.modalData.description,
			priority: null,
			status: null,
			assignedTo: null,
			// description: null,
			selectedassignedTo: null,
			newNote: '',
			selectedNotes: this.props.modalData.notes,
			prevselectedNotes: this.props.modalData.notes,
			messageNotes: this.props.modalData.messageNotes,

			selectedStatus:
				this.props.modalData.status === 'todo'
					? {
							label: (
								<span style={{ display: 'flex', alignItems: 'center' }}>
									<span className="delivarableStatusCheck">
										<b
											style={{
												backgroundColor: '#9F4DB7',
												marginRight: '15px',
											}}
										></b>
									</span>

									<span className="status-option-text">To Do</span>
								</span>
							),
							value: 'todo',
					  }
					: this.props.modalData.status === 'inProgress'
					? {
							label: (
								<span style={{ display: 'flex', alignItems: 'center' }}>
									<span className="delivarableStatusCheck">
										<b
											style={{
												backgroundColor: '#5383EC',
												marginRight: '15px',
											}}
										></b>
									</span>

									<span className="status-option-text">In Progress</span>
								</span>
							),
							value: 'inProgress',
					  }
					: this.props.modalData.status === 'inReview'
					? {
							label: (
								<span style={{ display: 'flex', alignItems: 'center' }}>
									<span className="delivarableStatusCheck">
										<b
											style={{
												backgroundColor: '#8EE2C7',
												marginRight: '15px',
											}}
										></b>
									</span>

									<span className="status-option-text">In Review</span>
								</span>
							),
							value: 'inReview',
					  }
					: this.props.modalData.status === 'done'
					? {
							label: (
								<span style={{ display: 'flex', alignItems: 'center' }}>
									<span className="delivarableStatusCheck">
										<b
											style={{
												backgroundColor: '#479A5F',
												marginRight: '15px',
											}}
										></b>
									</span>

									<span className="status-option-text">Done</span>
								</span>
							),
							value: 'done',
							color: '#FF8B00',
					  }
					: null,
			selectedpriority:
				this.props.modalData.priority === 'critical'
					? {
							value: 'critical',
							label: (
								<span style={{ display: 'flex' }}>
									<span
										className="task-prio-opts"
										style={{
											display: 'flex',
											flexDirection: 'column',
										}}
									>
										<CriticalP />
									</span>
									<span>Critical</span>
								</span>
							),
					  }
					: this.props.modalData.priority === 'high'
					? {
							value: 'high',
							label: (
								<span>
									<span className="task-prio-opts">
										<HighP />
									</span>
									<span>High</span>
								</span>
							),
					  }
					: this.props.modalData.priority === 'medium'
					? {
							value: 'medium',
							label: (
								<span>
									<span className="task-prio-opts">
										<MediumP />
									</span>
									<span>Medium</span>
								</span>
							),
					  }
					: this.props.modalData.priority === 'low'
					? {
							value: 'low',
							label: (
								<span>
									<span className="task-prio-opts">
										<LowP />
									</span>
									<span>Low</span>
								</span>
							),
					  }
					: null,
			priorityOptions: [
				{
					value: 'critical',
					label: (
						<span style={{ display: 'flex' }}>
							<span
								className="task-prio-opts"
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<CriticalP />
							</span>
							<span>Critical</span>
						</span>
					),
				},
				{
					value: 'high',
					label: (
						<span>
							<span className="task-prio-opts">
								<HighP />
							</span>
							<span>High</span>
						</span>
					),
				},
				{
					value: 'medium',
					label: (
						<span>
							<span className="task-prio-opts">
								<MediumP />
							</span>
							<span>Medium</span>
						</span>
					),
				},
				{
					value: 'low',
					label: (
						<span>
							<span className="task-prio-opts">
								<LowP />
							</span>
							<span>Low</span>
						</span>
					),
				},
			],
			statusPriorityOptions: [
				{
					label: (
						<span style={{ display: 'flex', alignItems: 'center' }}>
							<span className="delivarableStatusCheck">
								<b style={{ backgroundColor: '#9F4DB7', marginRight: '15px' }}></b>
							</span>

							<span className="status-option-text">To Do</span>
						</span>
					),
					value: 'todo',
				},

				{
					label: (
						<span style={{ display: 'flex', alignItems: 'center' }}>
							<span className="delivarableStatusCheck">
								<b style={{ backgroundColor: '#5383EC', marginRight: '15px' }}></b>
							</span>

							<span className="status-option-text">In Progress</span>
						</span>
					),
					value: 'inProgress',
				},
				{
					label: (
						<span style={{ display: 'flex', alignItems: 'center' }}>
							<span className="delivarableStatusCheck">
								<b style={{ backgroundColor: '#8EE2C7', marginRight: '15px' }}></b>
							</span>

							<span className="status-option-text">In Review</span>
						</span>
					),
					value: 'inReview',
				},
				{
					label: (
						<span style={{ display: 'flex', alignItems: 'center' }}>
							<span className="delivarableStatusCheck">
								<b style={{ backgroundColor: '#479A5F', marginRight: '15px' }}></b>
							</span>

							<span className="status-option-text">Done</span>
						</span>
					),
					value: 'done',
					color: '#FF8B00',
				},
			],
		};
	}
	handleCloseModal = () => {
		this.props.handleClose();
	};

	getAssignedToName = (assignedId) => {
		if (this.props.assignedToOptions && this.props.assignedToOptions.length !== 0) {
			for (let i = 0; i < this.props.assignedToOptions.length; i++) {
				if (this.props.assignedToOptions[i].value === assignedId) {
					return this.props.assignedToOptions[i].label;
				}
			}
		}

		return 'Unknown';
	};

	isDisabled = () => {
		return (
			this.state.description === null &&
			this.state.selectedassignedTo === null &&
			this.state.selecteddueDate === null &&
			this.state.priority === null &&
			this.state.status === null &&
			this.state.selectedNotes === this.state.prevselectedNotes
		);
	};
	editTaskApiCall = () => {
		let json = {
			updateTaskId: this.props.modalData.id,
		};
		if (this.state.description !== null) {
			json = {
				...json,
				updateInput: {
					...json.updateInput,
					title: this.state.description,
				},
			};
		}
		if (this.state.selectedassignedTo !== null) {
			json = {
				...json,
				updateInput: {
					...json.updateInput,
					assignedTo: {
						id: this.state.selectedassignedTo.value,
						name: this.state.selectedassignedTo.label,
					},
				},
			};
		}
		if (this.state.selecteddueDate !== null) {
			json = {
				...json,
				updateInput: {
					...json.updateInput,
					dueDate: this.state.selecteddueDate,
				},
			};
		}
		if (this.state.priority !== null) {
			json = {
				...json,
				updateInput: {
					...json.updateInput,
					priority: this.state.priority,
				},
			};
		}
		if (this.state.status !== null) {
			json = {
				...json,
				updateInput: {
					...json.updateInput,
					status: this.state.status,
				},
			};
		}
		if (this.state.messageNotes !== null && this.state.messageNotes.length > 0) {
			json = {
				...json,
				updateInput: {
					...json.updateInput,
					notes: this.state.selectedNotes.map((el) => {
						return { message: el.message };
					}),
				},
			};
		}
		this.updateTask(updateTask, json).then(() => {
			this.handleCloseModal();
		});
		// this.props.navigate(`/${this.props.params.vendorID}/tasks`);
		// .then(() => {
		// 	window.location.reload();
		// });
	};
	handleEventChange = (e, name) => {
		if (name === 'dueDate') {
			this.setState({
				selecteddueDate: parseInt(moment(e).format('yyyyMMDD')),
				dueDate: moment(e).format('yyyyMMDD'),
			});
		} else if (name === 'description') {
			this.setState({
				[name]: e.target.value,
			});
		} else {
			this.setState({
				[name]: e.value,
				[`selected${name}`]: e,
			});
		}
	};

	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'right-add'}
				custClass={_.has(this.props, 'custClass') ? this.props.custClass : ''}
			>
				<div className="project-add-edit-popup edit-shoot-details">
					<div
						className="project-add-edit-popup-header"
						style={{
							alignItems: this.props.activeShootID == null ? 'center' : 'flex-start',
							flexDirection: this.props.activeShootID == null ? 'row' : 'column',
							height: this.props.activeShootID == null ? '56px' : '70px',
						}}
					>
						<span className="header-title">Task {this.props.modalData.taskId}</span>
					</div>

					<div className="project-add-edit-popup-body">
						<div className="project-add-edit-popup-body-item" id={'details'}>
							{this.props.modalData.scope === 'deliverable' ? (
								<>
									<div className="popup-body-title">SCOPE</div>

									{/* <div className="floating-select-container"></div> */}

									<InputHeader
										type="text"
										name="workspace"
										value={this.props.modalData.workspaceName}
										readOnly={true}
										onChange={(e) => {}}
										isInputError={false}
										label="Workspace*"
									/>
									<InputHeader
										type="text"
										name="project"
										value={this.props.modalData.projectTitle}
										readOnly={true}
										onChange={(e) => {}}
										isInputError={false}
										label="Project*"
									/>
									<InputHeader
										type="text"
										name="deliverable"
										value={this.props.modalData.scopeName}
										readOnly={true}
										onChange={(e) => {}}
										isInputError={false}
										label="Deliverable*"
									/>
								</>
							) : null}
							{this.props.modalData.scope === 'workspace' ? (
								<>
									<div className="popup-body-title">SCOPE</div>

									{/* <div className="floating-select-container"></div> */}

									<InputHeader
										type="text"
										name="workspace"
										value={this.props.modalData.workspaceName}
										readOnly={true}
										onChange={(e) => {}}
										isInputError={false}
										label="Workspace*"
									/>
								</>
							) : null}
							{this.props.modalData.scope === 'project' ? (
								<>
									<div className="popup-body-title">SCOPE</div>

									{/* <div className="floating-select-container"></div> */}

									<InputHeader
										type="text"
										name="workspace"
										value={this.props.modalData.workspaceName}
										readOnly={true}
										onChange={(e) => {}}
										isInputError={false}
										label="Workspace*"
									/>
									<InputHeader
										type="text"
										name="project"
										value={this.props.modalData.projectTitle}
										readOnly={true}
										onChange={(e) => {}}
										isInputError={false}
										label="Project*"
									/>
								</>
							) : null}
							<div className="popup-body-title">TASK</div>
							<InputHeader
								type="text"
								name="description"
								value={this.state.description}
								readOnly={false}
								onChange={(e) => {
									this.handleEventChange(e, 'description');
								}}
								isInputError={false}
								label="Description*"
							/>
							<div
								className="floating-select-container"
								style={{
									zIndex: '88887999',
								}}
							>
								<label>Assigned To</label>
								<Select
									className="cost-select-container zIndex31 w-100p"
									classNamePrefix="cost-select"
									options={this.props.assignedToOptions}
									onChange={(e) => this.handleEventChange(e, 'assignedTo')}
									defaultValue={this.props.modalData.assignedTo}
									isSearchable={true}
									menuPosition={'fixed'}
								/>
							</div>
							<div
								style={{
									width: '100%',

									zIndex: '9999',
								}}
							>
								<DatePicker
									selected={
										this.state.dueDate !== null
											? moment(
													this.state.dueDate.toString(),
													'YYYYMMDD',
											  ).toDate()
											: ''
									}
									onChange={(e) => {
										this.handleEventChange(e, 'dueDate');
									}}
									dateFormat="dd/MM/yyyy"
									placeholderText="dd / mm / yyyy"
									openToDate={new Date()}
									customInput={<CustomDateInput customLabel="Due Date" />}
									wrapperClassName={`w-100p`}
								/>
							</div>
							<div
								className="floating-select-container"
								style={{
									zIndex: '7999',
								}}
							>
								<label>Priority*</label>
								<Select
									className="cost-select-container zIndex31 w-100p"
									classNamePrefix="cost-select"
									options={this.state.priorityOptions}
									onChange={(e) => this.handleEventChange(e, 'priority')}
									defaultValue={this.state.selectedpriority}
									isSearchable={true}
									// menuPortalTarget={document.body}
									menuPosition={'fixed'}
									// onMenuScrollToBottom={(e) => this.fetchMoreOptions()}
								/>
							</div>
							<div className="floating-select-container">
								<label>Status*</label>
								<Select
									className="cost-select-container zIndex31 w-100p"
									classNamePrefix="cost-select"
									options={this.state.statusPriorityOptions}
									onChange={(e) => this.handleEventChange(e, 'status')}
									defaultValue={this.state.selectedStatus}
									isSearchable={true}
									menuPosition={'fixed'}
								/>
							</div>

							<div className="popup-body-title">Notes</div>
							{this.state.selectedNotes !== null &&
							this.state.selectedNotes.length > 0 ? (
								<>
									{this.state.selectedNotes.map((e) => {
										return (
											<>
												<div
													style={{
														width: '100%',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'space-between',
													}}
												>
													<p
														style={{
															color: '#B0B0B0',
															fontSize: '13px',
															fontWeight: 400,
														}}
													>
														{e.createdBy
															? `by ${this.getAssignedToName(
																	e.createdBy,
															  )
																	.split(' ')
																	.map(
																		(word) =>
																			word
																				.charAt(0)
																				.toUpperCase() +
																			word.slice(1),
																	)
																	.join(' ')}, ${moment
																	.unix(e.createdAt)
																	.format('DD MMM YYYY hh:mm a')}`
															: ''}
													</p>
													<DeleteIcon
														style={{
															cursor: 'pointer',
														}}
														onClick={() => {
															this.setState({
																selectedNotes:
																	this.state.selectedNotes.filter(
																		(el) => el._id !== e._id,
																	),
															});
														}}
													/>
												</div>
												<div
													style={{
														marginTop: '-40px',
														width: '100%',
													}}
												>
													<InputHeader
														textarea={true}
														type="text"
														isInputError={false}
														width="100%"
														// readOnly={true}
														value={e.message}
														onChange={(event) => {
															this.setState({
																selectedNotes:
																	this.state.selectedNotes.map(
																		(el) => {
																			if (el._id === e._id) {
																				el.message =
																					event.target.value;
																			}
																			return el;
																		},
																	),
															});
														}}
													/>
												</div>
											</>
										);
									})}
								</>
							) : null}
							<InputHeader
								textarea={true}
								type="text"
								isInputError={false}
								label="New note"
								width="100%"
								onChange={(e) => {
									this.setState({
										newNote: e.target.value,
									});
								}}
								value={this.state.newNote}
								onBlur={(e) => {
									if (e.target.value !== '') {
										if (this.state.selectedNotes !== null) {
											this.setState({
												selectedNotes: [
													...this.state.selectedNotes,
													{ message: e.target.value },
												],
												messageNotes: [
													...this.state.messageNotes,
													{ message: e.target.value },
												],
												newNote: '',
											});
										}
									}
								}}
							/>
						</div>
					</div>

					<div className="bottom-popup-action-container">
						<span className="cancel-btn" onClick={() => this.handleCloseModal()}>
							Cancel
						</span>

						<span
							className={this.isDisabled() ? 'add-edit-btn disabled' : 'add-edit-btn'}
							onClick={(e) => {
								if (!this.isDisabled()) {
									this.editTaskApiCall();
								}
							}}
						>
							<span>Save</span>
						</span>
					</div>
				</div>
			</Modal>
		);
	}
}
export default withRouter(EditTask);
